var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-custom',{attrs:{"classes":"small","disabled":_vm.disabled,"color":"primary","label":"Lisää tuote","floatRight":_vm.floatRight},on:{"click":_vm.add}})}
var staticRenderFns = []

export { render, staticRenderFns }